import React, { useState, useEffect } from 'react';
import logo from '../assets/images/logo-mascoticas.png'; // Ruta de imagenes

const PanelAdministracion = ({ onLogout }) => {
  // Estados para datos
  const [usuarios, setUsuarios] = useState(JSON.parse(localStorage.getItem('usuarios')) || []);
  const [citas, setCitas] = useState(JSON.parse(localStorage.getItem('citas')) || []);
  const [logins, setLogins] = useState(JSON.parse(localStorage.getItem('logins')) || []);
  const [visitas, setVisitas] = useState(parseInt(localStorage.getItem('visitas')) || 0);
  const [filtroFecha, setFiltroFecha] = useState('');
  const [filtroUsuario, setFiltroUsuario] = useState('');
  const [filtroPropietario, setFiltroPropietario] = useState('');

  // Estados para reloj y clima
  const [horaActual, setHoraActual] = useState(new Date());
  const [clima, setClima] = useState({ temperatura: 24, condicion: 'soleado' });

  // Contador de visitas (corregido para evitar dependencia a `visitas`)
  useEffect(() => {
    setVisitas((prev) => {
      const nuevasVisitas = prev + 1;
      localStorage.setItem('visitas', nuevasVisitas.toString());
      return nuevasVisitas;
    });
  }, []);

  // Reloj en tiempo real y simulación de clima
  useEffect(() => {
    const intervaloReloj = setInterval(() => {
      setHoraActual(new Date());
      
      if (new Date().getMinutes() % 5 === 0) {
        setClima({
          temperatura: Math.floor(Math.random() * 10) + 20,
          condicion: ['soleado', 'parcialmente nublado', 'nublado'][Math.floor(Math.random() * 3)]
        });
      }
    }, 1000);

    return () => clearInterval(intervaloReloj);
  }, []);

  // Función para limpiar datos
  const limpiarDatos = () => {
    if (window.confirm('¿Está seguro que desea limpiar TODOS los datos? Esta acción no se puede deshacer.')) {
      localStorage.removeItem('usuarios');
      localStorage.removeItem('citas');
      localStorage.removeItem('logins');
      setUsuarios([]);
      setCitas([]);
      setLogins([]);
      alert('Todos los datos han sido eliminados correctamente');
    }
  };

  // Función para marcar cita como atendida
  const marcarAtendido = (citaId) => {
    const citasActualizadas = citas.map(cita => {
      if (cita.id === citaId) {
        return { ...cita, atendido: !cita.atendido };
      }
      return cita;
    });
    setCitas(citasActualizadas);
    localStorage.setItem('citas', JSON.stringify(citasActualizadas));
  };

  // Aplicar filtros
  const citasFiltradas = citas.filter(cita => {
    return (
      (filtroFecha === '' || cita.fecha.includes(filtroFecha)) &&
      (filtroUsuario === '' || cita.propietario.toLowerCase().includes(filtroUsuario.toLowerCase())) &&
      (filtroPropietario === '' || cita.propietario.toLowerCase().includes(filtroPropietario.toLowerCase()))
    );
  });

  // Función para exportar datos
  const exportarDatos = (tipo) => {
    let datos, nombreArchivo;
    
    switch(tipo) {
      case 'usuarios':
        datos = usuarios;
        nombreArchivo = 'usuarios_mascoticas.csv';
        break;
      case 'logins':
        datos = logins;
        nombreArchivo = 'logins_mascoticas.csv';
        break;
      case 'citas':
        datos = citas;
        nombreArchivo = 'citas_mascoticas.csv';
        break;
      default:
        return;
    }
    
    const blob = new Blob([JSON.stringify(datos, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nombreArchivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Estadísticas
  const totalCitas = citas.length;
  const citasAtendidas = citas.filter(c => c.atendido).length;
  const porcentajeCitasAtendidas = totalCitas > 0 ? Math.round((citasAtendidas / totalCitas) * 100) : 0;

  // Componente de gráfico circular
  const CircularProgress = ({ percentage, label, color }) => {
    const radius = 40;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percentage / 100) * circumference;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}>
        <svg width="100" height="100" viewBox="0 0 100 100">
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="#e0e0e0"
            strokeWidth="10"
          />
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth="10"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
          />
          <text
            x="50"
            y="50"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="20"
            fontWeight="bold"
          >
            {percentage}%
          </text>
        </svg>
        <div style={{ marginTop: '10px', fontWeight: 'bold' }}>{label}</div>
      </div>
    );
  };

  // Estilos personalizados
  const styles = {
    panel: {
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      background: 'linear-gradient(135deg, #ffd6e7 0%, #ffcce0 50%, #ffc2d9 100%)',
      minHeight: '100vh'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      paddingBottom: '10px',
      borderBottom: '2px solid rgba(255,255,255,0.5)'
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    },
    logo: {
      height: '60px',
      width: 'auto',
      borderRadius: '50%',
      border: '2px solid #ff66a3',
      boxShadow: '0 2px 10px rgba(255,102,163,0.3)'
    },
    title: {
      color: '#d6336c',
      margin: 0,
      textShadow: '1px 1px 2px rgba(255,255,255,0.8)'
    },
    infoClima: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      backgroundColor: 'rgba(255,255,255,0.3)',
      padding: '10px 15px',
      borderRadius: '20px',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
    },
    reloj: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      color: '#c9184a'
    },
    clima: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      color: '#c9184a'
    },
    card: {
      backgroundColor: 'rgba(255,255,255,0.7)',
      borderRadius: '15px',
      padding: '20px',
      marginBottom: '30px',
      boxShadow: '0 4px 8px rgba(255,102,163,0.2)'
    },
    button: {
      padding: '8px 15px',
      color: 'white',
      border: 'none',
      borderRadius: '20px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      backgroundColor: 'white'
    },
    tableHeader: {
      backgroundColor: '#f2f2f2',
      padding: '12px',
      textAlign: 'left',
      borderBottom: '1px solid #ddd'
    },
    tableCell: {
      padding: '12px',
      borderBottom: '1px solid #ddd'
    }
  };

  // Función para formatear la hora
  const formatearHora = (fecha) => {
    return fecha.toLocaleTimeString('es-CO', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  // Función para obtener ícono del clima
  const getClimaIcono = (condicion) => {
    switch(condicion) {
      case 'soleado': return '☀️';
      case 'parcialmente nublado': return '⛅';
      case 'nublado': return '☁️';
      default: return '🌤️';
    }
  };

  return (
    <div style={styles.panel}>
      {/* Barra superior con logo, título, reloj y botones */}
      <div style={styles.header}>
        <div style={styles.logoContainer}>
          <img 
            src={logo} 
            alt="Logo Mascoticas" 
            style={styles.logo}
            onError={(e) => {
              e.target.onerror = null; 
              e.target.src = 'https://via.placeholder.com/60?text=Logo';
            }}
          />
          <h1 style={styles.title}>Panel de Administración</h1>
        </div>
        
        <div style={styles.infoClima}>
          <div style={styles.reloj}>
            <span className="material-icons" style={{ verticalAlign: 'middle' }}>Clima</span>
            {' ' + formatearHora(horaActual)}
          </div>
          <div style={styles.clima}>
            <span style={{ fontSize: '1.5rem' }}>{getClimaIcono(clima.condicion)}</span>
            <div>
              <div style={{ fontWeight: 'bold' }}>{clima.temperatura}°C</div>
              <div style={{ fontSize: '0.8rem' }}>{clima.condicion}</div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button 
            onClick={limpiarDatos}
            style={{ ...styles.button, backgroundColor: '#ff4d6d' }}
          >
            <span className="material-icons">Limpiar Datos</span>
            
          </button>
          <button 
            onClick={onLogout}
            style={{ ...styles.button, backgroundColor: '#ff8fa3' }}
          >
            <span className="material-icons">Cerrar Sesión</span>
            
          </button>
        </div>
      </div>

      {/* Sección de Estadísticas */}
      <div style={styles.card}>
        <h2 style={{ color: '#333', marginBottom: '20px' }}>Estadísticas Generales</h2>
        
        <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
          <div style={{ textAlign: 'center', padding: '15px', minWidth: '150px' }}>
            <h3 style={{ color: '#555', marginBottom: '10px' }}>Visitas Totales</h3>
            <div style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold',
              color: '#007bff',
              backgroundColor: 'white',
              borderRadius: '50%',
              width: '100px',
              height: '100px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              {visitas}
            </div>
          </div>
          
          <CircularProgress 
            percentage={usuarios.length} 
            label="Usuarios Registrados" 
            color="#28a745" 
          />
          
          <CircularProgress 
            percentage={porcentajeCitasAtendidas} 
            label="Citas Atendidas" 
            color="#17a2b8" 
          />
          
          <CircularProgress 
            percentage={logins.length} 
            label="Inicios de Sesión" 
            color="#ffc107" 
          />
        </div>
      </div>

      {/* Sección de Filtros */}
      <div style={{ ...styles.card, marginBottom: '20px' }}>
        <h3 style={{ marginTop: '0', color: '#555' }}>Filtros</h3>
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: 'bold' }}>Fecha: </label>
            <input 
              type="date" 
              value={filtroFecha}
              onChange={(e) => setFiltroFecha(e.target.value)}
              style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: 'bold' }}>Usuario: </label>
            <input 
              type="text" 
              placeholder="Filtrar por usuario"
              value={filtroUsuario}
              onChange={(e) => setFiltroUsuario(e.target.value)}
              style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: 'bold' }}>Propietario: </label>
            <input 
              type="text" 
              placeholder="Filtrar por propietario"
              value={filtroPropietario}
              onChange={(e) => setFiltroPropietario(e.target.value)}
              style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ display: 'flex', gap: '10px', alignSelf: 'flex-end' }}>
            <button 
              onClick={() => {
                setFiltroFecha('');
                setFiltroUsuario('');
                setFiltroPropietario('');
              }}
              style={{
                padding: '8px 15px',
                backgroundColor: '#ff4444',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginBottom: '5px'
              }}
            >
              Limpiar filtros
            </button>
          </div>
        </div>
      </div>

      {/* Botones de Exportación */}
      <div style={{ 
        display: 'flex', 
        gap: '10px', 
        marginBottom: '20px',
        justifyContent: 'flex-end'
      }}>
        <button 
          onClick={() => exportarDatos('usuarios')}
          style={{
            padding: '8px 15px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer'
          }}
        >
          Exportar Usuarios
        </button>
        <button 
          onClick={() => exportarDatos('logins')}
          style={{
            padding: '8px 15px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer'
          }}
        >
          Exportar Logins
        </button>
        <button 
          onClick={() => exportarDatos('citas')}
          style={{
            padding: '8px 15px',
            backgroundColor: '#ff9800',
            color: 'white',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer'
          }}
        >
          Exportar Citas
        </button>
      </div>

      {/* Tabla de Usuarios */}
      <div style={{ ...styles.card, marginBottom: '30px' }}>
        <h2 style={{ color: '#333' }}>Usuarios Registrados ({usuarios.length})</h2>
        <div style={{ overflowX: 'auto' }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.tableHeader}>Identificación</th>
                <th style={styles.tableHeader}>Nombre</th>
                <th style={styles.tableHeader}>Contacto</th>
                <th style={styles.tableHeader}>Email</th>
                <th style={styles.tableHeader}>Fecha Registro</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map(usuario => (
                <tr key={usuario.id} style={{ borderBottom: '1px solid #ddd', ':hover': { backgroundColor: '#f5f5f5' } }}>
                  <td style={styles.tableCell}>{usuario.tipoIdentificacion} {usuario.identificacion}</td>
                  <td style={styles.tableCell}>{usuario.nombre}</td>
                  <td style={styles.tableCell}>{usuario.contacto || usuario.celular || 'N/A'}</td>
                  <td style={styles.tableCell}>{usuario.email}</td>
                  <td style={styles.tableCell}>{usuario.fechaRegistro}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Tabla de Citas con Checkbox */}
      <div style={{ ...styles.card, marginBottom: '30px' }}>
        <h2 style={{ color: '#333' }}>Citas Agendadas ({citasFiltradas.length})</h2>
        <div style={{ overflowX: 'auto' }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.tableHeader, width: '50px' }}>Atendido</th>
                <th style={styles.tableHeader}>Tipo</th>
                <th style={styles.tableHeader}>Fecha</th>
                <th style={styles.tableHeader}>Hora</th>
                <th style={styles.tableHeader}>Mascota</th>
                <th style={styles.tableHeader}>Propietario</th>
                <th style={styles.tableHeader}>Contacto</th>
              </tr>
            </thead>
            <tbody>
              {citasFiltradas.map(cita => (
                <tr 
                  key={cita.id} 
                  style={{ 
                    borderBottom: '1px solid #ddd', 
                    backgroundColor: cita.atendido ? '#e8f5e9' : 'transparent',
                    ':hover': { backgroundColor: cita.atendido ? '#d0e9d0' : '#f5f5f5' }
                  }}
                >
                  <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                    <input 
                      type="checkbox" 
                      checked={cita.atendido || false}
                      onChange={() => marcarAtendido(cita.id)}
                      style={{ transform: 'scale(1.2)', cursor: 'pointer' }}
                    />
                  </td>
                  <td style={styles.tableCell}>{cita.tipo}</td>
                  <td style={styles.tableCell}>{cita.fecha}</td>
                  <td style={styles.tableCell}>{cita.hora}</td>
                  <td style={styles.tableCell}>{cita.mascota}</td>
                  <td style={styles.tableCell}>{cita.propietario}</td>
                  <td style={styles.tableCell}>{cita.telefono}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Tabla de Logins */}
      <div style={styles.card}>
        <h2 style={{ color: '#333' }}>Estadísticas de Accesos ({logins.length})</h2>
        <div style={{ overflowX: 'auto' }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.tableHeader}>Nombre</th>
                <th style={styles.tableHeader}>Email</th>
                <th style={styles.tableHeader}>Contacto</th>
                <th style={styles.tableHeader}>Fecha</th>
                <th style={styles.tableHeader}>Tipo</th>
              </tr>
            </thead>
            <tbody>
              {logins.map((login, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #ddd', ':hover': { backgroundColor: '#f5f5f5' } }}>
                  <td style={styles.tableCell}>{login.nombre}</td>
                  <td style={styles.tableCell}>{login.email}</td>
                  <td style={styles.tableCell}>{login.contacto || 'N/A'}</td>
                  <td style={styles.tableCell}>{login.fecha}</td>
                  <td style={styles.tableCell}>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      backgroundColor: login.tipo === 'admin' ? '#dc3545' : 
                                      login.tipo === 'login' ? '#28a745' : '#17a2b8',
                      color: 'white',
                      fontSize: '0.8rem'
                    }}>
                      {login.tipo === 'admin' ? 'Administrador' : 
                       login.tipo === 'login' ? 'Usuario' : 'Registro'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PanelAdministracion;
